<template>
  <div class="main-wrapper" v-if="extensions">
    <el-tabs v-model="activeName" @tab-click="btnTabsClick">
      <el-tab-pane label="我的插件" name="my">
      </el-tab-pane>
      <el-tab-pane label="官方插件" name="published">
      </el-tab-pane>
    </el-tabs>

    <el-table :data="extensions" width="100%">
      <el-table-column label="插件名称">
        <template #default="scope">
          {{ scope.row.displayName }}
        </template>
      </el-table-column>
      <el-table-column label="插件Id" width="150">
        <template #default="scope">
          {{ scope.row.userName }}.{{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="最新版本" width="150">
        <template #default="scope">
          {{ scope.row.latestVersion }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间" width="150">
        <template #default="scope">
          {{ scope.row.updatedDate }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="400">
        <template #default="scope">
          <div v-if="isAuthenticated(scope.row)" class="actions">
            <el-link type="primary" :underline="false" :disabled="!isHostExists" href="javascript:;" @click.prevent="btnDeployClick(scope.row)">部署到网站云</el-link>
            <el-link type="primary" :underline="false" href="javascript:;" @click.prevent="btnDownloadClick(scope.row)">下 载</el-link>
            <el-link
              type="danger"
              :underline="false"
              href="javascript:;"
              v-if="scope.row.userName === userName"
              @click.prevent="btnDeleteClick(scope.row)"
            >
              删 除
            </el-link>
          </div>
          <div v-else class="actions">
            <el-link type="primary" :underline="false" href="javascript:;" :disabled="true">部署到网站云</el-link>
            <el-link type="primary" :underline="false" href="javascript:;" @click.prevent="btnBuyClick(scope.row)">购 买</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer title="购买插件" direction="rtl" size="60%" v-model="isBuy">
      <buy :userName="extension.userName" :name="extension.name" @close="btnBuyCloseClick" />
    </el-drawer>

    <el-drawer title="部署到网站云" direction="rtl" size="60%" v-model="isDeploy">
      <deploy :userName="extension.userName" :name="extension.name" @close="isDeploy = false" />
    </el-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IExtension } from '@/types/models';
import utils from '@/utils';
import api from '@/api/my/plugins';
import Deploy from './components/plugins/Deploy.vue';
import Buy from './components/plugins/Buy.vue';

interface IState {
  activeName: string;
  extensions: IExtension[];
  orderResourceIds: string[];
  userName: string;
  isHostExists: boolean;
  extension: IExtension;
  isBuy: boolean;
  isDeploy: boolean;
}

export default defineComponent({
  components: {
    Deploy,
    Buy,
  },
  data() {
    return {
      activeName: 'my',
      extensions: [],
      orderResourceIds: [],
      userName: '',
      isHostExists: false,
      extension: {} as IExtension,
      isBuy: false,
      isDeploy: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get({ type: this.activeName }, (res) => {
        this.extensions = res.extensions;
        this.orderResourceIds = res.orderResourceIds;
        this.userName = res.userName;
        this.isHostExists = res.isHostExists;
      });
    },

    apiDelete(extension: IExtension) {
      api.delete(
        {
          name: extension.name,
        },
        (res) => {
          if (!res) return;
          utils.success('插件删除成功！');
          this.apiGet();
        },
      );
    },

    getUrl(relatedUrl: string) {
      return `https://sscms.com/extensions/${relatedUrl}`;
    },

    getDownloadUrl(extension: IExtension) {
      return `https://dl.sscms.com/extensions/${extension.userName}/T_${extension.name}.zip`;
    },

    isAuthenticated(extension: IExtension) {
      if (extension.price > 0 && extension.userName !== this.userName) {
        return this.orderResourceIds.indexOf(extension.guid) !== -1;
      }
      return true;
    },

    btnTabsClick() {
      this.apiGet();
    },

    btnBuyClick(extension: IExtension) {
      this.extension = extension;
      this.isBuy = true;
    },

    btnDeployClick(extension: IExtension) {
      this.isDeploy = true;
      this.extension = extension;
    },

    btnDownloadClick(extension: IExtension) {
      api.getExtension(
        {
          userName: extension.userName,
          name: extension.name,
        },
        (res) => {
          if (!res) return;
          window.open(res.extensionDownloadUrl);
        },
      );
    },

    btnDeleteClick(extension: IExtension) {
      utils.alertDelete(
        {
          title: '删除插件',
          text: `此操作将删除插件 ${extension.name}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(extension);
        },
      );
    },

    btnBuyCloseClick() {
      this.isBuy = false;
      this.apiGet();
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
